import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// The page must sit still in someone's hand at the counter: a stray pinch mid-scan is
// disruptive. iOS Safari deliberately ignores `user-scalable=no` for pinch (it has since
// iOS 10), and these Safari-only gesture events are the only thing that actually stops it.
// Double-tap zoom is handled by `touch-action` and focus auto-zoom by the 16px control floor,
// both in index.css. Trade-off, accepted deliberately: this also removes pinch-to-magnify,
// which is why that 16px floor matters rather than being cosmetic.
for (const type of ["gesturestart", "gesturechange", "gestureend"]) {
  document.addEventListener(type, (e: Event) => e.preventDefault(), { passive: false });
}

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
